import { createSelector } from 'reselect';

const translationsSelector = state => state.meta.i18n.learn;

export const getAskTheExpertToggleTranslations = createSelector(
  translationsSelector,
  translations => ({
    form: {
      action: translations.expert.learner.submit_alt,
      heading: translations.expert.library.title,
      placeholder: translations.expert.library.placeholder,
      close: translations.common.close,
      cancel: translations.common.cancel,
    },
    successMessage: {
      heading: translations.expert.learner.sent_title,
      body: translations.expert.learner.sent_body_alt,
      close: translations.common.close,
    },
  }),
);
